import { render, staticRenderFns } from "./SmallVideosList.vue?vue&type=template&id=654aa9ec&scoped=true"
import script from "./SmallVideosList.vue?vue&type=script&lang=js"
export * from "./SmallVideosList.vue?vue&type=script&lang=js"
import style0 from "./SmallVideosList.vue?vue&type=style&index=0&id=654aa9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.36.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654aa9ec",
  null
  
)

export default component.exports